import { useWindowResize } from 'src/ui/dom/useWindowResize'
import { useMountedState } from 'src/ui/react/useMountedState'

enum Sizes {
    xs = 360,
    sm = 480,
    md = 768,
    lg = 1024,
    xl = 1600,
    landscapeH = 600
}

export const ScreenSize = {
    Sizes,
    isMobileScreen: (size: number) =>
        size <= Sizes.md ||
        (window.innerHeight <= Sizes.landscapeH &&
            window.matchMedia('(orientation: landscape)').matches)
}

export const isMobileScreen = () => {
    const [v, setV] = useMountedState(
        ScreenSize.isMobileScreen(window.innerWidth)
    )

    useWindowResize(w => setV(ScreenSize.isMobileScreen(w)))

    return v
}

export const isScreenSize = (max: number) => {
    const isSize = (current: number) => current <= max

    const [v, setV] = useMountedState(isSize(window.innerWidth))

    useWindowResize(w => setV(isSize(w)))

    return v
}

const calcScreenSize = (w: number): number => {
    if (w >= Sizes.xl) return Sizes.xl
    else if (w < Sizes.xl && w >= Sizes.lg) return Sizes.xl
    else if (w < Sizes.lg && w >= Sizes.md) return Sizes.lg
    else if (w < Sizes.md && w >= Sizes.sm) return Sizes.md
    else if (w < Sizes.sm && w >= Sizes.xs) return Sizes.sm
    else return Sizes.xs
}

export const getScreenSize = (): number => {
    const [v, setV] = useMountedState(calcScreenSize(window.innerWidth))

    useWindowResize(w => setV(calcScreenSize(w)))
    return v
}
